import React, { useEffect } from "react";
import { Section } from "../../components/Container/Section";
import { SectionTitleWithExp } from "../../components/customTypo/SectionTitleWithExp";
import { CardContainerRetro } from "../../components/Container/CardContainerRetro";
import { Text } from "@mantine/core";
import colorsCustom from "../../designTokens/colorsCustom";
import { Flex, Grid } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { trackEvent } from "../../utils/analytics";
import { useFriendsInteractionData } from "../../hooks/useThreadsSelector";
import { GridSkeleton } from "../skeleton/GridSkeleton";
import { useIsMobile } from "../../hooks/useIsMobile";
import { FriendInteractionCard } from "../Card/FriendInteractionCard";

export const FriendsInteractionSection = ({ onUserClick }) => {
  const { t } = useTranslation();

  // 반응형 Hook
  const isMobile = useIsMobile("xl");

  // ThreadsContext에서 친구 상호작용 데이터 가져오기
  const {
    repliesByUser,
    lifetimeReplies,
    isRepliesLoading,
    isProcessing,
    isDataReady,
    error,
  } = useFriendsInteractionData();



  useEffect(() => {
    // const fetchProfileImages = async () => {
    // 	const images = {};
    // 	for (const user of repliesByUser) {
    // 		try {
    // 			const response = await axios.get(
    // 				`https://www.threads.net/@${user.username}`
    // 			);
    // 			const html = response.data;
    // 			const $ = load(html);
    // 			const imageUrl = $(
    // 				"xl1xv1r x14yjl9h xudhj91 x18nykt9 xww2gxu xvapks4 x1bgq0ue"
    // 			).attr("src");
    // 			images[user.username] = imageUrl;
    // 		} catch (error) {
    // 			console.error(`Error fetching data for ${user.username}: `, error);
    // 		}
    // 	}
    // 	setProfileImages(images);
    // };
    // fetchProfileImages();
  }, [repliesByUser]);



  // 에러 처리 - 기본값과 함께 에러 상태 표시
  if (error && repliesByUser.length === 0) {
    return (
      <Section>
        <SectionTitleWithExp title={t("friendsInteraction")} />
        <CardContainerRetro
          p={isMobile ? "16px" : "24px"}
          bg={colorsCustom.paper}
          weight="bold"
          rd={16}
        >
          <Flex direction="column" align="center" gap={16}>
            <Text c="orange" ta="center" size="sm">
              ⚠️ {t("error.friends_interaction")}
            </Text>
            <Text ta="center" c="dimmed">
              {t("empty.friends_interaction")}
            </Text>
          </Flex>
        </CardContainerRetro>
      </Section>
    );
  }

  // 로딩 중
  if (isRepliesLoading || isProcessing || !isDataReady) {
    return <GridSkeleton title={t("friendsInteraction")} />;
  }

  // 첫 번째 항목(나 자신) 제거
  const otherUsers = repliesByUser ? repliesByUser.slice(1) : [];

  // 데이터가 없는 경우
  if (!repliesByUser || repliesByUser.length === 0 || otherUsers.length === 0) {
    return (
      <Section>
        <SectionTitleWithExp title={t("friendsInteraction")} />
        <CardContainerRetro
          p={isMobile ? "16px" : "24px"}
          bg={colorsCustom.paper}
          weight="bold"
          rd={16}
        >
          <Text ta="center" c="dimmed">
            {t("empty.friends_interaction")}
          </Text>
        </CardContainerRetro>
      </Section>
    );
  }

    return (
    <Section>
      <SectionTitleWithExp title={t("allFriends")} />
      
      <CardContainerRetro
        p={isMobile ? "16px" : "48px 32px 48px 24px"}
        bg={colorsCustom.paper}
        weight="bold"
        rd={16}
        style={{ position: "relative" }}
      >
        <Grid w="100%" wrap="wrap" gutter="48px">
          {otherUsers.slice(0, 20).map((user, index) => (
            <Grid.Col span={isMobile ? 6 : 3} key={user.username}>
              <FriendInteractionCard
                rank={index + 6} // 6위부터 시작 (1-5위는 TopFriendsSection에서)
                user={user}
                size="small"
                isMobile={isMobile}
                showRank={false}
                onClick={() => {
                  if (onUserClick) {
                    onUserClick(user.username);
                  }
                  trackEvent("Reply_By_Friends_Clicked", {
                    username: user.username,
                  });
                }}
              />
            </Grid.Col>
          ))}
        </Grid>
      </CardContainerRetro>
    </Section>
  );
};
